import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { AppSettings } from './app-settings';
import { AuthenticationService } from './services/authentication.service';
import { ShoppingCartService } from './services/shopping-cart.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  admin: boolean = false;
  checkout: boolean = false;
  panelAdmin: boolean = false;

  totemActive: boolean = AppSettings.ENV_TOTEM;
  numTicketsCart: number = 0;
  cartTotem: boolean = true;
  noChrome: boolean = false;
  noFooter: boolean = false;

  constructor(private router: Router, private titleService: Title, private auth: AuthenticationService,
    private shoppingCartService: ShoppingCartService) {
    this.titleService.setTitle('CityLok');
    var viewAdmin = localStorage.getItem('admin');
    var rol = localStorage.getItem('currentRol');
    this.router.events
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          var url = event.url;
          this.admin = url.indexOf('/admin') == -1 ? false : true;
          this.checkout = url.indexOf('/checkout/') == -1 ? false : true;
          this.panelAdmin = url.indexOf('/panel-control') == -1 ? false : true;
          this.cartTotem = url.indexOf('/cart-checkout') == -1 ? false : true;
          this.noChrome = url.indexOf('/vincular-abono') == -1 ? false : true;
          // La ficha de evento (y su borrador) cierra con la barra de compra
          // fija, así que en móvil no lleva pie. En escritorio sí.
          this.noFooter = url.indexOf('/event/') == -1 ? false : true;
        }
      }
      );
    this.admin = (rol === 'true' && viewAdmin) ? true : false;
    // if(localStorage.getItem('jwt_token')) {
    //   this.auth.getUsersMe().subscribe({
    //     next: result => { if (result.email) { 
    //       this.auth.setProfile(result);
    //     } }
    //   });
    // }
  }

  ngOnInit() {
    if (AppSettings.ENV_TOTEM) {
      // Sesión del kiosco: se autentica sola y se renueva si el token falta o
      // ha caducado (el JWT caduca a los 3 días y el tótem no se cierra nunca).
      this.auth.ensureTotemSession().subscribe(() => {
        this.getCartUser();
      });
    }
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

  getCartUser() {
    this.shoppingCartService.updateCartObservable.subscribe({
      next: (res) => {
        this.shoppingCartService.getCartUser().subscribe({
          next: (value) => {
            this.numTicketsCart = value.cart?.tickets?.length || 0;
          },
          error: (err) => {
            this.numTicketsCart = 0;
          }
        });
      }
    });
  }
}
